
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tuki/[slug]",
      function () {
        return require("private-next-pages/tuki/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tuki/[slug]"])
      });
    }
  